module.exports = __webpack_public_path__ + "img/ErrorMessageImg.2bd748ca.svg";